import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { LoginPage } from "./components/loginPage/LoginPage"
import { ErrorPageGeneral } from "./components/errorPage/ErrorPageGeneral"
import { RedirectToLogin } from "./components/loginPage/RedirectToLogin"
import { LayoutContainer } from "./components/layout/LayoutContainer"
import { ScheduleNavigation } from "./components/schedule/ScheduleNavigation"
import { ConfigurationsNavigation } from "./components/configurations/ConfigurationsNavigation"
import { TrackNavigation } from "./components/track/TrackNavigation"
import { ErrorPage404 } from "./components/errorPage/ErrorPage404"
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react"
import { commonRoutes } from "./components/shared/commonConstants"
import { LandingPage } from "./components/landing/landingPage/LandingPage"
import { setMsalInstance } from "./utils/msalInstance"
import { AdminFunctionsNavigation } from "./components/adminFunctions/AdminFunctionsNavigation"

function App() {

  const { accounts } = useMsal();

  if (accounts && accounts.length > 0) { setMsalInstance(); }  // Make sure the msal instance is created to get the roles

  const routerForUnauthorized = createBrowserRouter([
    {
      path: "/",
      element: <LoginPage />,
      errorElement: <ErrorPageGeneral />
    },
    {
      path: "*", element: <RedirectToLogin />
    }
  ])

  const router = createBrowserRouter([
    {
      path: "/",
      element: <LayoutContainer />,
      errorElement: <ErrorPageGeneral />,
      children: [
        { path: commonRoutes.landing, element: <LandingPage /> },
        ...ScheduleNavigation(),
        ...ConfigurationsNavigation(),
        ...TrackNavigation(),
        ...AdminFunctionsNavigation()
      ],
    },
    {
      path: "*", element: <ErrorPage404 />
    }
  ])

  return (
    <div className="App">
      <UnauthenticatedTemplate>
        <RouterProvider router={routerForUnauthorized} />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <RouterProvider router={router} />
      </AuthenticatedTemplate>
    </div>
  )
}

export default App
